/** @jsx jsx */
import { useState } from 'react';
import { jsx, Box } from 'theme-ui';
import Headroom from 'react-headroom';
import styled from '@emotion/styled';
import HeaderLogo from '../logo/headerMainLogo.jsx';
import BurgerMenuButton from './BurgerMenuButton';
import EmailSignup from '../emailSignup/emailSignup';
import themeHarrys from '../../gatsby-plugin-theme-ui';
import themeLume from '../../gatsby-plugin-theme-ui-lume';
import themeMando from '../../gatsby-plugin-theme-ui-mando';
import themeHaven from '../../gatsby-plugin-theme-ui-haven/index.js';
import themeSpruce from '../../gatsby-plugin-theme-ui-spruce';

// This file only runs serverside
function generateBrandSpecificComponents (brand) {
  var theme, 
    customCTA_styles, 
    container_styles = '',
    customNavMobileMenu_styles = '',
    navMobile_styles = `
      padding: 1em 1em 1em 2em;
    `,
    customNav_styles,
    customNavMenu_styles,
    PromoBar = null,
    promoBarText = '',
    NavTitle = null;

  switch(brand) {
    case 'kelly':
      theme = themeHaven;
      NavTitle = styled.span`
        font-family: ${theme.fonts.playfair};
        font-size: 24px;
        font-weight: 200;
        line-height: 1.3;
        letter-spacing: 0;
        color: #333333;
        text-transform: none;
        padding: 0 1em 0 0;
        margin-left: 0.5em;
        @media only screen and (min-width: 880px) {
          font-size: 32px;
        }
        @media only screen and (max-width: 880px) {
          margin-left: 0.25em;
        }
      `;
      customCTA_styles = styled.a`
        margin-left: auto;
        margin-right: 10px;
        appearance: none;
        align-items: center;
        background-color: transparent;
        border: 1px solid #333333;
        border-radius: 0;
        color: #000;
        display: inline-flex;
        font-family: ${theme.fonts.lato};
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        justify-content: center;
        line-height: 1.5;
        letter-spacing: 0.05em;
        padding: 0.875em 1.75em;
        position: relative;
        vertical-align: middle;
        white-space: nowrap;
        transition: background-color 0.3s ease;
        cursor: pointer;
        text-transform: uppercase;
        text-decoration: none;

        &:hover {
          background-color: #E8DCCF;
          border-color: #333333;
          transition: background-color 0.3s ease;
        }

        &:focus {
          outline: none;
          box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.2);
        }

        @media only screen and (min-width: 48em) {
          padding: 0.875em 2em;
        }

        @media only screen and (max-width: 880px) {
          font-size: 14px;
          padding: 0.75em 1.5em;
        }
      `;
      break;

    case 'spruce':
      theme = themeSpruce;
      customCTA_styles = styled.a`
        margin-left: auto;
        margin-right: 0;
        appearance: none;
        align-items: center;
        background-color: #3c519d;
        border: 1px solid #3c519d;
        border-radius: 0;
        color: #fff;
        display: inline-flex;
        font-family: ${theme.fonts.poppins};
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        justify-content: center;
        line-height: 1.5;
        letter-spacing: 0.02em;
        padding: 0.6em 1.25em;
        position: relative;
        vertical-align: middle;
        white-space: nowrap;
        transition: background-color 0.25s ease, color 0.25s ease;
        cursor: pointer;
        text-transform: none;
        text-decoration: none;

        &:hover {
          background-color: #fff;
          color: #3c519d;
          border-color: #3c519d;
        }

        &:focus {
          outline: none;
          box-shadow: 0 0 0 2px rgba(60, 81, 157, 0.3);
        }

        @media only screen and (min-width: 48em) {
          padding: 0.6em 1.5em;
        }

        @media only screen and (max-width: 880px) {
          font-size: 13px;
          padding: 0.5em 1em;
        }
      `;

      customNavMenu_styles = `
        font-size: 15px;
        font-weight: 400;
        display: flex;
        align-items: center;
        padding: 0.75em 1em;
        vertical-align: middle;
        letter-spacing: 0.01em;
        text-transform: none;
      `;

      customNav_styles = `
        .nav-content {
          align-items: center;
        }
        .spruce-nav-link:hover {
          color: #3c519d;
          text-decoration: none;
        }
      `;

      container_styles = `
        background: #ffffff;
        border-bottom: 1px solid #e8e4de;
        height: auto;
        min-height: ${theme.sizes.navHeight};
      `;

      navMobile_styles = `
        padding: 1em 1em 1em 1.5em;
      `;

      NavTitle = styled.span`
        font-size: 20px;
        font-weight: 600;
        letter-spacing: 0.02em;
        color: #000;
        font-family: ${theme.fonts.poppins};
        padding: 0 1em 0 0;
        margin-left: 0.5em;
        @media only screen and (max-width: 880px) {
          font-size: 16px;
          padding: 0 0.5em 0 0;
          margin-left: 0.25em;
        }
      `;
      break;
    case 'mando':
      theme = themeMando;
      customCTA_styles = styled.a`
        margin-left: auto;
        padding: 0.6em 1em 0.6em;
        background-color: #275681;
        color: #FFF;
        font-size: 17px;
        font-style: normal;
        font-weight: bold;
        line-height: 1.5;
        margin-bottom: medium;
        padding: ['0.75em', '0.75em 3em'];
        vertical-align: 'middle';
        border-radius: 0;
        border-top-right-radius: 8px;
        border-bottom-left-radius: 8px;
        text-decoration: none;

        @media only screen and (max-width: 550px) {
          padding: 5px;
          font-size: 16px;
        }
      `;

      customNavMenu_styles = `
        color: rgba(255,255,255,.75);
        font-family: 'Roboto';
        text-transform: none;
        font-size: 16px;
        font-weight: normal;

        &:hover {
          color: #fff;
        }  
      `;

      customNavMobileMenu_styles = `
        background-color: rgb(13,13,13);
        font-size: 18px;
        a {
          color: #fff;
        }
      `;
     

      break;
    case 'lume':
      theme = themeLume;
      customCTA_styles = styled.a`
        display: inline-block;
        background: #2196f3;
        padding: 0.5em 2em;
        border-radius: 50px;
        text-align: center;
        color: #fff!important;
        font-weight: 400;
        text-transform: uppercase;
        -webkit-transition: ease all .2s;
        transition: ease all .2s;
        margin-left: auto;
        text-decoration: none;
        font-size: 16px;
        font-family: 'Lato';

        &:hover {
          background: #0960a5;
        }

        @media only screen and (max-width: 880px) {
          font-size: 14px;
          margin-top: -5px;
          margin-right: 5px;
        }

        @media only screen and (max-width: 640px) {
          margin-top: -12px;
        }
      `;

      container_styles = `
        #logo {
          width: 200px;
        }

        @media only screen and (max-width: 880px) {
          height: 80px;
          #logo {
            width: 105px;
          }
          #logo svg {
            width: 85px;
            height: 70px;
          }
        }

        @media only screen and (max-width: 640px) {
          height: 60px;
          #logo {
            margin-top: -7px;
            width: 105px;
          }
          #logo svg {
            width: 75px;
            height: 60px;
          }
        }
      `;

      navMobile_styles = `
        padding: 0.75em 0.5em 0.5em 2em;
      `;

      customNavMenu_styles = `
        color: rgb(67,84,83);
        padding: 1em 1em 0.6em;
        -webkit-text-decoration: none;
        text-decoration: none;
        font-size: 16px;
        font-weight: 900;
        font-family: 'Poppins-Bold';
      `;
      break;
    case 'harrys':
      theme = themeHarrys;
      navMobile_styles += `height: 68px`;
      container_styles = `
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
        box-shadow: rgba(0, 0, 0, 0.15) 1px 2px 6px 0px;
      `;
      break;
    default:
        theme = themeHarrys;
  };

  const brandColors = theme.referenceColors;
  const Container = styled.header`
    background: ${brandColors.background};
    font-family: ${theme.fonts.heading};
    font-size: ${theme.styles.root.header.fontSize};
    font-weight: ${theme.fontWeights.heading};
    height: ${theme.sizes.navHeight};
    display: flex;
    align-items: center;

    ${container_styles} 
  `;

  const MobileNavigationButton = styled(BurgerMenuButton)`
    @media only screen and (min-width: 881px) {
      display: none;
    }
  `;

  const Navigation = styled.nav`
    align-items: center;
    display: flex;
    height: 100%;
    margin: 0 auto;
    max-width: 1400px;
    padding: 1em 1em 1em 2em;
    text-transform: uppercase;
    width: 100%;
    
    .nav-content {
      width: 100%;
      display: flex;
      align-items: center;
    }
  
    ${customNav_styles}

    @media only screen and (max-width: 880px) {
      ${navMobile_styles}
    }
  `;

  const NavList = styled.div`
    margin-left: 16px;
    display: flex;
    align-items: center;

    a {
      color: ${brandColors.navList};
      display: inline-flex;
      align-items: center;
      padding: 1em 1em 0.6em;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }

      ${customNavMenu_styles}
    }

    @media only screen and (max-width: 880px) {
      display: none;

      &.open {
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 1px 5px 1px rgb(0 0 0 / 25%);
        display: block;
        left: 0;
        position: absolute;
        top: 4rem;
        z-index: 999;

        a {
          display: block;
          padding: 1.4em 1.4em 1em;
        }

        ${customNavMobileMenu_styles}
      }
    }
  `;

  var HeaderCTAButton = customCTA_styles ? customCTA_styles : styled.a`
      color: ${brandColors.headerCTA};
      font-family: ${theme.fonts.nav};
      margin-left: auto;
      padding: 0.6em 1em 0.6em;
    `;

  return { Container, MobileNavigationButton, Navigation, NavList, HeaderCTAButton, PromoBar, promoBarText, NavTitle }
}

const Header = ({ regionConfig, pageData }) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const { Container, MobileNavigationButton, Navigation, NavList, HeaderCTAButton, PromoBar, promoBarText, NavTitle } = generateBrandSpecificComponents( regionConfig.brand );
  const isSpruce = regionConfig.brand === 'spruce';
  const isKelly = regionConfig.brand === 'kelly';
  
  var headroomStyles = {
        zIndex: 9999,
      };

  if(regionConfig.brand === 'harrys') {
    headroomStyles.boxShadow = '1px 1px 1px rgba(0,0,0,0.25)';
  }

  // Grab cta text and link from page properties if set. If not set, use region config default text and link
  var ctaText = (pageData?.navCtaText || regionConfig?.headerCTA?.title || 'Sign up').trim(),
      ctaLink = pageData?.navCtaLink ?? regionConfig?.headerCTA?.url ?? '';

  const emailSignupConfig = pageData?.navCtaEmailPopup ?? pageData?.data?.navCtaEmailPopup;
  const showNav = (regionConfig?.headerNavigation?.length > 0) || (pageData?.navMenu?.length > 0);

  // Only pass non-empty values so EmailSignup can use its defaults in prod when Builder data is missing or empty
  const str = (v) => (typeof v === 'string' && v.trim() ? v.trim() : undefined);
  const navEmailButtonText = str(emailSignupConfig?.buttonText) ?? str(ctaText) ?? undefined;
  const navEmailPopupTitle = str(emailSignupConfig?.popupTitle) ?? undefined;
  const navEmailPopupSubtitle = str(emailSignupConfig?.popupSubTitle) ?? undefined;
  const navEmailPopupButtonText = str(emailSignupConfig?.popupButtonText) ?? undefined;
  const navEmailPlaceholder = str(emailSignupConfig?.placeholderText) ?? undefined;
  const navEmailEndpoint = str(emailSignupConfig?.zapierEndpoint) ?? undefined;
  const navEmailRedirect = str(emailSignupConfig?.redirectUrl) ?? undefined;

  return (
    <Headroom
      style={headroomStyles}
      upTolerance={0}
    >
      <Container>
        <Navigation>
          <div className="nav-content">
          {showNav &&
            <MobileNavigationButton
              onClick={() => setMobileNavOpen(!mobileNavOpen)}
            />
          }
          <a href={`https://www.${regionConfig.domain}`} id="logo" style={{ 'lineHeight': 1}}>
            <HeaderLogo regionConfig={regionConfig} />
          </a>
          {NavTitle && isSpruce && (
            <img width="200px" style={{ marginTop: '-10px' }} src="https://cdn.builder.io/api/v1/image/assets%2Ff9dd6bab38b6461a948dbc919c8394de%2F56e2fde36c184a5d9694164eec8ddb91"></img>
          )}
          {NavTitle && isKelly && (
            <NavTitle>Haven Health</NavTitle>
          )}
          {!isKelly && (
            <NavList className={mobileNavOpen ? 'open' : 'closed'}>
              {regionConfig.headerNavigation && regionConfig.headerNavigation.map((link) => (
                <a key={link.url} href={`https://${regionConfig.domain}${link.url}`} className={isSpruce ? 'spruce-nav-link' : ''}>
                  {link.title}
                </a>
              ))}
              {pageData?.navMenu && pageData?.navMenu.map((link) => (
                <a key={link.url} href={`${link.url}`} className={isSpruce ? 'spruce-nav-link' : ''}>
                {link.text}
              </a>
              ))}
            </NavList>
          )}

          {!pageData?.navHideCta &&
            (regionConfig.brand === 'spruce' ? (
              <Box sx={{ ml: 'auto', mr: 0, mt: '5px' }}>
                <EmailSignup
                  buttonText={navEmailButtonText}
                  buttonVariant="primary"
                  popupTitle={navEmailPopupTitle}
                  popupSubtitle={navEmailPopupSubtitle}
                  popupButtonText={navEmailPopupButtonText}
                  placeholderText={navEmailPlaceholder}
                  apiEndpoint={navEmailEndpoint}
                  redirectUrl={navEmailRedirect}
                  regionConfig={regionConfig}
                />
              </Box>
            ) : (
              <HeaderCTAButton id="navCTA" href={ctaLink}>
                {ctaText}
              </HeaderCTAButton>
            ))
          }
          </div>
        </Navigation>
      </Container>
    </Headroom>
  );
};

export default Header;
